import {
  Control,
  FieldValues,
  UseControllerProps,
  useFormState,
} from "react-hook-form";

import Description from "../Description";
import FieldError from "../FieldError";
import Label from "../Label";
import SimplifiedFormRowProps from "../SimplifiedFormRowProps";
import Select, { SelectProps } from "./Select";

/**
 * Displays a edit form row with a Select
 * @param props - SimplifiedFormRowProps, just id and what to display: label, inlineDescription, longDescription
 * @returns
 */
export default function SelectFormRow<T extends FieldValues>(
  props: SimplifiedFormRowProps &
    SelectProps &
    UseControllerProps<T> & { control: Control<T> }
) {
  const { errors, touchedFields } = useFormState({
    control: props.control,
    name: props.name,
    exact: true,
  });
  const isTouched = touchedFields[props.name];
  const error = errors[props.name];

  return (
    <div className="row mb-3">
      <Label
        label={props.label}
        id={props.id}
        isError={!!error /*&& !!isTouched*/}
        description={props.longDescription}
      ></Label>
      <div className="col-sm-8">
        <Select {...props}></Select>
        <Description description={props.inlineDescription}></Description>
        <FieldError
          error={error?.message as string | null | undefined}
        ></FieldError>
      </div>
    </div>
  );
}
